import React from 'react';
import './MeetingItem.css';

interface MeetingItemProps {
  title: string;
  time: string;
  date: string;
  tag: 'Regular' | 'Committee' | 'Special';
  location: string;
  attendeesCount: number;
  inProgress: boolean;
}

const MeetingItem: React.FC<MeetingItemProps> = ({
  title,
  time,
  date,
  tag,
  location,
  attendeesCount,
  inProgress
}) => {
  // Determine if meeting is in past or future
  const isPast = React.useMemo(() => {
    const meetingDateTime = new Date(`${date} ${time}`);
    const now = new Date();
    return meetingDateTime < now;
  }, [date, time]);

  // Format date to "Monday, 1 Jan 2024"
  const formattedDate = React.useMemo(() => {
    const dateObj = new Date(date);
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    const dayName = days[dateObj.getDay()];
    const dayNum = dateObj.getDate();
    const monthName = months[dateObj.getMonth()];
    const year = dateObj.getFullYear();

    return `${dayName}, ${dayNum} ${monthName} ${year}`;
  }, [date]);

  // Format time to include GST
  const formattedTime = `${time} GST`;

  const getTagClassName = () => {
    switch (tag) {
      case 'Regular':
        return 'meeting-tag-regular';
      case 'Committee':
        return 'meeting-tag-committee';
      case 'Special':
        return 'meeting-tag-special';
      default:
        return 'meeting-tag-regular';
    }
  };

  return (
    <div className={`meeting-item ${isPast ? 'meeting-past' : 'meeting-future'}`}>
      <div className="meeting-column meeting-column-1">
        <div className="meeting-title-row">
          <div className="meeting-item-title">{title}</div>
          <span className={`meeting-tag ${getTagClassName()}`}>{tag}</span>
        </div>
        <div className="meeting-datetime">
          <span className="meeting-date">{formattedDate}</span>
          <span className="meeting-separator">|</span>
          <span className="meeting-time">{formattedTime}</span>
        </div>
      </div>

      <div className="meeting-column meeting-column-2">
        <div className="meeting-location">{location}</div>
        <div className="meeting-attendees">{attendeesCount} Attendees</div>
      </div>

      <div className="meeting-column meeting-column-3">
        <button className="meeting-btn meeting-btn-details">
          View Details
        </button>
      </div>
    </div>
  );
};

export default MeetingItem;
